if (!customElements.get('menu-swiper')) {
    class MenuSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.checkSubmenus();
            this.switchProductList();
        }

        checkSubmenus() {
            const menuListOuter = this.querySelectorAll('.menu-item-has-grandchild-container-product-box-list-outer');
            this.swipers = [];
            if (menuListOuter.length) {
                menuListOuter.forEach((menuOuter) => {
                    const menuList = menuOuter.querySelector('.menu-item-has-grandchild-container-product-box-list');
                    const nextButton = menuOuter.querySelector('.swiper-button-next');
                    const prevButton = menuOuter.querySelector('.swiper-button-prev');
                    const number = parseInt(this.getAttribute('data-number'), 10) || 4;
                    const centerInsufficientSlides = this.getAttribute('data-center-insufficient-slides') === 'true';
                    const swiper = new Swiper(menuList, {
                        slidesPerView: number || 4,
                        spaceBetween: 30,
                        observer: true,
                        navigation: {
                            nextEl: nextButton || null,
                            prevEl: prevButton || null,
                        },
                        ...(centerInsufficientSlides && { centerInsufficientSlides: true }),
                        on: {
                            init: function (swiper) {
                                const hideElements = menuList.parentElement;
                                if (hideElements && hideElements.getAttribute('aria-expanded') === 'false') {
                                    // console.log(hideElements, 'hideElements');
                                    hideElements.style.display = 'none';
                                }
                            },
                        },
                    });

                    this.swipers.push(swiper);
                });
            }
        }

        switchProductList() {
            const menuTitleList = this.querySelector('.menu-item-has-grandchild-container-list');
            const menuProductList = this.querySelector('.menu-item-has-grandchild-container-product-box');
            if (menuTitleList) {
                const menuTitles = menuTitleList.querySelectorAll('.menu-item-children-item[data-collection]');
                const menuProductContainers = menuProductList.querySelectorAll('.menu-item-has-grandchild-container-product-box-list-outer[data-collection]');

                if (menuTitles.length) {
                    menuTitles.forEach((menuTitle) => {
                        menuTitle.addEventListener('mouseenter', () => {
                            menuTitles.forEach((title) => {
                                title.setAttribute('aria-expanded', 'false');
                            })
                            menuTitle.setAttribute('aria-expanded', 'true');

                            const targetData = menuTitle.getAttribute('data-collection');

                            const targetProductContainer = Array.from(menuProductContainers).find(container =>
                                container.getAttribute('data-collection') === targetData
                            );

                            if (targetProductContainer) {
                                menuProductContainers.forEach(container => {
                                    container.setAttribute('aria-expanded', 'false');
                                    container.style.display = 'none';
                                });
                                targetProductContainer.setAttribute('aria-expanded', 'true');
                                targetProductContainer.style.display = '';
                            }
                        });
                    });
                }
            }
        }
    }
    customElements.define('menu-swiper', MenuSwiper);
}